import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import React, { useEffect, useState } from 'react';
import { Button, TextField, InputAdornment } from '@material-ui/core';
import Swal from 'sweetalert2'

import Prompt from '../Shared/Prompt/Prompt';
import PromptWrapper from '../Shared/Prompt/Wrapper';
import PromptActions from '../Shared/Prompt/Actions';

import { forgotPw } from '../../Functions/auth';

import { decodeHTMLEntities } from '../../Functions/utils';
import { toastTimerValue} from '../../Shared/utils';
import '../SweetAlert.css'


export default function Forgot() {
  const history = useHistory();
  const { t } = useTranslation();

  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);


  const handleForgot = async (e) => {
    e.preventDefault();

    if (!email) {
      return toast(decodeHTMLEntities(t('forgot.errors.incomplete')), {type: 'error'});
      // return Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('forgot.errors.incomplete'),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }
  
    setLoading(true);
    const res = await forgotPw(email, localStorage.getItem('lang'));
    setLoading(false);
    
    if (!res || !res.success) {
      return toast(decodeHTMLEntities(t('forgot.errors.' + res)), {type: 'error'});
      
      // return Swal.fire({
      //   toast: true,
      //   icon: 'error',
      //   title: t('forgot.errors.' + res),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    }

    setEmailSent(true);
  };

  const goBack = (e) => {
    e.preventDefault();
    history.goBack();
  };


  useEffect(() => {
    document.title = t('forgot.page');
  }, [t]);


  return (
    <Prompt>
      {!emailSent ? (
        <form className="prompt__container" style={{height: '90%'}} onSubmit={handleForgot}>
          <Button onClick={goBack} className="back__button">
            <span className="material-icons-round" style={{fontSize: '48px'}}>chevron_left</span>
          </Button>

          <PromptWrapper>
            <div className="prompt__title" style={{marginTop: '8px'}}>
              <h1>{t('forgot.title')}</h1>
              <p>{t('forgot.subtitle')}</p>
            </div>

            <div className="prompt__content">
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">account_circle</span>
                  </InputAdornment>
                }}
                name="username"
                variant="outlined"
                label={t('forgot.field')}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </PromptWrapper>

          <PromptActions column>
            <Button className="btnPrimary" type="submit" disabled={!email || loading}>
              {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('forgot.button')}
            </Button>
          </PromptActions>
        </form>
      ) : (
        <div className="prompt__container" style={{height: '90%', justifyContent: 'center'}}>
          <div className="prompt__title">
            <h1 style={{marginBottom: '30px'}}>{t('forgot.title_sent')}</h1>
            <p>{t('forgot.subtitle_sent')}</p>
          </div>
        </div>
      )}
    </Prompt>
  );
}
